export default "__VITE_ASSET__DCcutGGG__"